/**
 * SECTION 1A JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_triangles_circles from './aon_craft_triangles_circles.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Section 1A, data
         * UI interaction functions etc
         */
        console.log( 'Section 1A - init' );
        
        var where_do_you_take_inspiration = '';
        
        this.aon_section_1a_data = [];
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 1A...
            if ( $( '#section_1a_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        // Render Data...
        this.renderData();
                
        
        // Enable Next button if "take inspiration" textarea is not empty...
        $( 'body' ).on( 'keyup', '#where_do_you_get_inspiration', function( event ) {
            if ( $( this ).val() !== '' ) {
                $( '.take_inspiration_next' ).removeClass( 'disabled' );
            } else {
                $( '.take_inspiration_next' ).addClass( 'disabled' );
            }
            setTextfieldData( $( this ).val() );
            event.preventDefault();
        });
        
        var setTextfieldData = ( value ) => {
            this.aon_section_1a_data[ 0 ][ 'where_do_you_take_inspiration' ] = value;
            console.table( this.aon_section_1a_data );
        }
        
        // Click on "take inspiration" Next link...
        $( 'body' ).on( 'click', '.take_inspiration_next', function( event ) {
            where_do_you_take_inspiration = $( '#where_do_you_get_inspiration' ).val();
            console.log( 'where_do_you_take_inspiration: ' + where_do_you_take_inspiration );
            event.preventDefault();
        });
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
          

    },
    
    renderData() {
        console.log( 'renderData - Section 1A');
        $.each( this.aon_section_1a_data, function( index ) {
            // Loop over data entries...   
            $( '#where_do_you_get_inspiration' ).val( this.where_do_you_take_inspiration );
            if ( this.where_do_you_take_inspiration !== '' ) {
                $( '.take_inspiration_next' ).removeClass( 'disabled' );
            } else {
                $( '.take_inspiration_next' ).addClass( 'disabled' );
            }
            
            //this.i_love_items
            if ( this.i_love_items !== '' ) {
                aon_craft_triangles_circles.loadUserArrayItems( 'i_love_items', this.i_love_items );
            }
      
            //this.i_want_to_items
            if ( this.i_want_to_items !== '' ) {
                aon_craft_triangles_circles.loadUserArrayItems( 'i_want_to_items', this.i_want_to_items );
            }
            
            //this.i_am_items
            if ( this.i_am_items !== '' ) {
                aon_craft_triangles_circles.loadUserArrayItems( 'i_am_items', this.i_am_items );
            }
            
        });
    },
    
    addDataEntry() {
        console.log( 'addDataEntry - start' );
        // Default variables for data structure...
        var where_do_you_take_inspiration = '';
        var i_love_items = '';
        var i_want_to_items = '';
        var i_am_items = '';
        
        // Push default data to data structure array...
        this.aon_section_1a_data.push( { where_do_you_take_inspiration, i_love_items, i_want_to_items, i_am_items } );
        //this.i_want_to_array.push( { name: name, status: status } );
        console.log( 'addDataEntry: '  );
        console.table( this.aon_section_1a_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_1a_data_json = $( '#section_1a_data_json' ).val();
			//console.log( 'aon_section_1a_data_json:' );
			//console.log( aon_section_1a_data_json );
            this.aon_section_1a_data = JSON.parse( aon_section_1a_data_json );
            console.log( 'Print aon_section_1a_data to table' );
            console.table( this.aon_section_1a_data );
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_section_1a_data_json = '[';
                aon_section_1a_data_json += '{"where_do_you_take_inspiration":"Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum id ligula porta felis euismod semper. Etiam porta sem malesuada magna mollis euismod. Donec ullamcorper nulla non metus auctor fringilla. Lorem ipsum dolor sit amet, consectetur adipiscing elit.","i_love_items":[{"name":"What you’re passionate about","status":""},{"name":"Working with my community","status":""},{"name":"Working alone","status":""},{"name":"Working on my own ideas","status":""},{"name":"Solving problems","status":""},{"name":"Working to commission","status":""},{"name":"Making beautiful things","status":""},{"name":"Making challenging work","status":""},{"name":"Making useful things","status":""}],"i_want_to_items":[{"name":"Create an income for yourself","status":""},{"name":"Preserve traditions","status":""},{"name":"Promote health and wellbeing","status":""},{"name":"Push new technology","status":""},{"name":"Solving problems","status":""},{"name":"Promote equality","status":""},{"name":"Combine new ways of working","status":""},{"name":"Protect the environment","status":""},{"name":"Challenge beliefs","status":""}],"i_am_items":[{"name":"Efficient","status":""},{"name":"Confident","status":""},{"name":"A good listener","status":""},{"name":"Optimistic","status":""},{"name":"Effective","status":""},{"name":"Reliable","status":""},{"name":"Hardworking","status":""},{"name":"Good at asking questions","status":""},{"name":"Dependable","status":""},{"name":"Resilient","status":""},{"name":"Determined","status":""},{"name":"Thorough","status":""},{"name":"Effective","status":""},{"name":"Systematic","status":""},{"name":"Logical","status":""},{"name":"Organised","status":""},{"name":"Attentive","status":""}]}';
                aon_section_1a_data_json += ']';

            this.aon_section_1a_data = JSON.parse( aon_section_1a_data_json );
            console.table( this.aon_section_1a_data );
            
        } else if ( mode == 'start' ) {
            this.addDataEntry();
            
        }
      
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        this.aon_section_1a_data[ 0 ][ 'i_love_items' ] = aon_craft_triangles_circles.getArrayData( 'i_love_items' );
        this.aon_section_1a_data[ 0 ][ 'i_want_to_items' ] = aon_craft_triangles_circles.getArrayData( 'i_want_to_items' );
        this.aon_section_1a_data[ 0 ][ 'i_am_items' ] = aon_craft_triangles_circles.getArrayData( 'i_am_items' );
        
        var jsonDataString = JSON.stringify( this.aon_section_1a_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '1A AJAX - START' );
        var meta = { 'section_1a_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '1A AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_1a_data );
        
        console.log( aon_craft_triangles_circles.getArrayData( 'i_love_items' ) );
        console.log( aon_craft_triangles_circles.getArrayData( 'i_want_to_items' ) );
        console.log( aon_craft_triangles_circles.getArrayData( 'i_am_items' ) );
        
        /*this.aon_section_1a_data[ 0 ][ 'where_do_you_take_inspiration' ] = where_do_you_take_inspiration;
        this.aon_section_1a_data[ 0 ][ 'i_love_items' ] = aon_craft_triangles_circles.getArrayData( 'i_love_items' );
        this.aon_section_1a_data[ 0 ][ 'i_want_to_items' ] = aon_craft_triangles_circles.getArrayData( 'i_want_to_items' );
        this.aon_section_1a_data[ 0 ][ 'i_am_items' ] = aon_craft_triangles_circles.getArrayData( 'i_am_items' );*/
    }

}